<style lang="less" scoped>
.title-div {
    font-weight: 600;
    margin: 10px 0 10px;
    font-size: 26px;
    flex-grow: 1;
    color: #000;
    height: 30px;
}

.pileItem-div {
    font-weight: 600;
    //   margin: 0 10px !important;
    font-size: 20px;
    // flex-grow: 1;
    color: #000;
    // height: 30px;
}

.el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;

    >div:first-of-type {
        // width: 120px;
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    >div:last-of-type {
        font-size: 14px;
        min-width: 160px;
        text-align: right;
        margin-left: 20px;
    }
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">共享预约订单详情</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="title-div">基础信息</div>
                <el-row :gutter="20">
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">共享预约订单编号</div>
                        <div>{{ detailForm.reserveOrderNo || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">充电桩IMEI编号</div>
                        <div>{{ detailForm.deviceCode || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">充电业务归属</div>
                        <div>{{ detailForm.bindSourceName || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">订单状态</div>
                        <div>{{ detailForm.orderStatusName || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">共享设备类型</div>
                        <div>{{ detailForm.deviceTypeName || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">共享预约类型</div>
                        <div>{{ detailForm.reserveTypeName || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">充电用户账号类型</div>
                        <div>{{ detailForm.custTypeName || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">设备所属用户手机号</div>
                        <div>{{ detailForm.custMobile || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">下单用户手机号</div>
                        <div>{{ detailForm.custPhone || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex align-items">
                        <div class="cust-detail-title">当前预约开始时间</div>
                        <div>{{ detailForm.localReserveBeginTime || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex align-items ">
                        <div class="cust-detail-title">当前预约结束时间</div>
                        <div>{{ detailForm.localReserveEndTime || '-' }}</div>
                    </el-col>
                    <el-col :xs="8" :sm="8" :md="8" :lg="8" class="flex">
                        <div class="cust-detail-title">站点名称</div>
                        <div>{{ detailForm.stationName || '-' }}</div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" class="flex">
                        <div class="cust-detail-title">站点地址</div>
                        <div>{{ detailForm.stationAddr || '-' }}</div>
                    </el-col>
                </el-row>
                <div class="title-div">预约时段</div>
                <el-table class="el-table" :data="tableData" border max-height="500px"
                    style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
                    <el-table-column type="index" width="50" label="序号" />
                    <el-table-column prop="startTime" label="预约开始时间" />
                    <el-table-column prop="endTime" label="预约结束时间" />
                    <el-table-column prop="currentStatus" label="预约时段状态" />
                    <el-table-column prop="createdWhen" label="创建时间" />
                </el-table>
                <!-- <div class="flex-r-end margin-t-20">
                    <button class="common-empty-button" @click="back()">返 回</button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import pageConfig from './page-config';
export default {
    data() {
        return {
            pageConfig,
            detailBreadCrumb: pageConfig.detailBreadCrumb,
            tableData: [], // 表格数据
            detailForm: {},
            reserveOrderNo: '',
        }
    },
    methods: {
        init() {
            let _ = this;
            _.reserveOrderNo = _.$route.query.reserveOrderNo || null
            if (_.reserveOrderNo) {
                _.$H.post(_, _.$A.digitization.getShareOrderInfo, {reserveOrderNo: _.reserveOrderNo}).then(res => {
                    const list = res.data.data || {};
                    _.detailForm = list.pileOrderShareOrderVO || {};
                    _.tableData = list.reserveOrderTimeList || [];
                })
            }
        },
        back() {
            this.$router.go(-1)
        }
    },
    mounted() {
        // this.mainTitle = this.$route.name =='unusualList'? '异常充电订单':'正常充电订单'
        this.init();
    }
}
</script>